<template>
  <div id="ag-grid-demo">
    <!-- START SOCIETY FILTER BLOCK -->
    <div class="vx-col w-full mb-base">
      <div class="filter_container">
        <vx-card title="Sélection du client" class="mr-4 filter_card w-1/3">
          <p>
            Sélectionner le client pour lequel vous souhaitez voir les
            statisques
          </p>
          <div class="vx-row">
            <div class="vx-col sm:w-full w-full mb-2">
              <vs-select
                autocomplete
                v-model="society"
                class="w-full select-large mt-4"
                label="Choisissez un client"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.name"
                  v-for="(item, index) in allSocieties"
                  class="w-full"
                />
              </vs-select>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- END FILTER BLOCK -->

    <!-- URL LOADING BAR -->
    <div class="center" v-if="startFetchingSitemap">
      <vx-card class="w-1/2">
        <div class="w-full">
          <p>Récupération des URLs du client...</p>
          <vs-progress :height="10" :percent="loadingPercent" color="primary"
            >primary</vs-progress
          >
        </div>
      </vx-card>
    </div>

    <!-- SPEED TEST LOADING BAR -->
    <div class="center" v-if="startFetching">
      <vx-card class="w-1/2">
        <div class="w-full">
          <p>Test de vitesse en cours ...</p>
          <vs-progress :height="10" :percent="loadingPercent" color="primary"
            >primary</vs-progress
          >
        </div>
      </vx-card>
    </div>

    <!-- SHOW URL BUTTON -->
    <div class="center" v-if="showUrls == false && !startFetching">
      <vx-card class="w-1/4">
        <div class="w-full center">
          <vs-button color="primary" @click="showUrls = true">Afficher les urls</vs-button>
        </div>
      </vx-card>
    </div>

    <!-- URL TABLE  -->
    <vx-card
      title="URL contenus dans le sitemap"
      v-if="societyUrls && !startFetching && showUrls"
      class="w-full"
    >
      <vs-table
        pagination
        max-items="10"
        stripe
        :data="societyUrls"
        v-if="societyUrls"
      >
        <template slot="thead">
          <vs-th>Favoris</vs-th>
          <vs-th><span class="w-full">URL</span></vs-th>
          <vs-th><span class="center w-full">Note Desktop</span></vs-th>
          <vs-th><span class="center w-full">Note Mobile</span></vs-th>
          <vs-th><span class="center w-full">Dernier rapport</span></vs-th>
          <vs-th><span class="txt_align_right w-full"></span></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(row, index) in data">
            <vs-td class="img_thumbnail w-1/6">
              <vx-tooltip
                text="Ajouter ou supprimer des favoris"
                position="top"
              >
                <vs-checkbox
                  v-model="row.isFavorite"
                  @click="updateSociety()"
                ></vs-checkbox>
              </vx-tooltip>
            </vs-td>
            <vs-td class="url_box w-2/4">{{ decodeURI(row.url) }}</vs-td>
            <vs-td
              class="fw-bold pointer"
              @click.native="checkDataAvailability(row.url, 'desktop')"
            >
              <span class="center">
                <vx-tooltip
                  text="Cliquer pour lancer le test de vitesse"
                  position="top"
                >
                  <vs-chip
                    v-if="row.desktop_score"
                    :color="getColorForScore(row.desktop_score)"
                    >{{ row.desktop_score * 100 }}</vs-chip
                  >
                  <vs-icon v-else icon="get_app" size="small"></vs-icon>
                </vx-tooltip>
              </span>
            </vs-td>
            <vs-td
              class="fw-bold pointer"
              @click.native="checkDataAvailability(row.url, 'mobile')"
            >
              <span class="center">
                <vx-tooltip
                  text="Cliquer pour lancer le test de vitesse"
                  position="top"
                >
                  <vs-chip
                    v-if="row.mobile_score"
                    :color="getColorForScore(row.mobile_score)"
                    >{{ row.mobile_score * 100 }}</vs-chip
                  >
                  <vs-icon v-else icon="get_app" size="small"></vs-icon>
                </vx-tooltip>
              </span>
            </vs-td>
            <vs-td class="fw-bold">
              <span v-if="row.last_update" class="center">{{
                getDateToFrenchFormat(row.last_update)
              }}</span>
              <span v-else class="center">Aucun rapport</span>
            </vs-td>
            <!-- UPDATE ROW DATA BUTTON -->
            <vs-td class="fw-bold txt_align_right">
              <!--
                  <vx-tooltip text="Rafraîchir les données" position="top">
                    <vs-icon icon="update" size="small"></vs-icon>
                  </vx-tooltip>-->
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- END URL TABLE -->

    <div v-if="selectedSociety && selectedData && !startFetching" class="mt-4">
      <!-- SPEED TEST RESULT CONTAINER -->
      <vx-card title="Résultat du speed test" class="mr-4">
        <div
          class="center"
          v-if="reviewChartOptions || desktopChartOptions || mobileChartOptions"
        >
          <!-- SPEED TEST RADIAL CHART -->
          <SimpleRadial
            :chartParams="reviewChartOptions"
            name="Ordinateur"
            :loadingTime="selectedData.timing.total / 1000"
            :score="selectedData.categories.performance.score * 100"
          />
        </div>
        <div class="center">
          <h2>{{ selectedData.requestedUrl }}</h2>
        </div>
        <!-- SCORE HELPER -->
        <div class="center">
          <vs-chip class="mt-4 mr-6" color="#ff4e42">0 - 49</vs-chip>
          <vs-chip class="mt-4 mr-6" color="#ffa400">50 - 89</vs-chip>
          <vs-chip class="mt-4" color="#20E647">90 - 100</vs-chip>
        </div>
      </vx-card>

      <!-- PERFORMANCE CONTAINER -->
      <vx-card title="Performance" v-if="selectedData">
        <div class="vx-row">
          <div class="vx-col flex-1">
            <vx-tooltip
              :text="selectedData.audits['first-contentful-paint'].description"
              position="top"
            >
              <statistics-card-line
                hideChart
                class="mb-base"
                :icon="
                  getIconForScore(
                    selectedData.audits['first-contentful-paint'].score
                  )
                "
                :statistic="
                  selectedData.audits['first-contentful-paint'].displayValue
                "
                :statisticTitle="
                  selectedData.audits['first-contentful-paint'].title
                "
                :color="
                  getThemeColorForScore(
                    selectedData.audits['first-contentful-paint'].score
                  )
                "
              />
            </vx-tooltip>
          </div>
          <div class="vx-col flex-1">
            <vx-tooltip
              :text="selectedData.audits.interactive.description"
              position="top"
            >
              <statistics-card-line
                hideChart
                class="mb-base"
                :icon="getIconForScore(selectedData.audits.interactive.score)"
                :statistic="selectedData.audits.interactive.displayValue"
                :statisticTitle="selectedData.audits.interactive.title"
                :color="
                  getThemeColorForScore(selectedData.audits.interactive.score)
                "
              />
            </vx-tooltip>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col flex-1">
            <vx-tooltip
              :text="selectedData.audits['speed-index'].description"
              position="top"
            >
              <statistics-card-line
                hideChart
                class="mb-base"
                :icon="
                  getIconForScore(selectedData.audits['speed-index'].score)
                "
                :statistic="selectedData.audits['speed-index'].displayValue"
                :statisticTitle="selectedData.audits['speed-index'].title"
                :color="
                  getThemeColorForScore(
                    selectedData.audits['speed-index'].score
                  )
                "
              />
            </vx-tooltip>
          </div>

          <div class="vx-col flex-1">
            <vx-tooltip
              :text="selectedData.audits['total-blocking-time'].description"
              position="top"
            >
              <statistics-card-line
                hideChart
                class="mb-base"
                :icon="
                  getIconForScore(
                    selectedData.audits['total-blocking-time'].score
                  )
                "
                :statistic="
                  selectedData.audits['total-blocking-time'].displayValue
                "
                :statisticTitle="
                  selectedData.audits['total-blocking-time'].title
                "
                :color="
                  getThemeColorForScore(
                    selectedData.audits['total-blocking-time'].score
                  )
                "
              />
            </vx-tooltip>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col flex-1">
            <vx-tooltip
              :text="
                selectedData.audits['largest-contentful-paint'].description
              "
              position="top"
            >
              <statistics-card-line
                hideChart
                class="mb-base"
                :icon="
                  getIconForScore(
                    selectedData.audits['largest-contentful-paint'].score
                  )
                "
                :statistic="
                  selectedData.audits['largest-contentful-paint'].displayValue
                "
                :statisticTitle="
                  selectedData.audits['largest-contentful-paint'].title
                "
                :color="
                  getThemeColorForScore(
                    selectedData.audits['largest-contentful-paint'].score
                  )
                "
              />
            </vx-tooltip>
          </div>

          <div class="vx-col flex-1">
            <vx-tooltip
              :text="selectedData.audits['cumulative-layout-shift'].description"
              position="top"
            >
              <statistics-card-line
                hideChart
                class="mb-base"
                :icon="
                  getIconForScore(
                    selectedData.audits['cumulative-layout-shift'].score
                  )
                "
                :statistic="
                  selectedData.audits['cumulative-layout-shift'].displayValue
                "
                :statisticTitle="
                  selectedData.audits['cumulative-layout-shift'].title
                "
                :color="
                  getThemeColorForScore(
                    selectedData.audits['cumulative-layout-shift'].score
                  )
                "
              />
            </vx-tooltip>
          </div>
        </div>
      </vx-card>

      <!-- OPPORTUNITIES CONTAINER -->
      <div class="center">
        <!-- OPPORTUNITIES TABLE -->
        <SuggestionsTable
          :suggestionData="opportunities"
          tableName="Opportunités"
          v-if="selectedData"
        />
      </div>

      <!-- DIAGNOSTIC CONTAINER -->
      <div class="center mt-8">
        <!-- DIAGNOSTIC TABLE -->
        <SuggestionsTable
          :suggestionData="diagnostics"
          tableName="Diagnostic"
          v-if="selectedData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import {AgGridVue} from "ag-grid-vue";
import chartsMixin from "../../mixins/chartsMixin";
import utilsMixin from "../../mixins/utilsMixin";
import sortMixin from "../../mixins/sortingMixin";
import pageSpeedScoreMixin from "../../mixins/pageSpeedScoreMixin";
import StatisticsCardLine from "../../components/views/dashboard/statistics-cards/StatisticsCardLine.vue";
import commonSelect from "../../mixins/formhelpers/commonSelect";

// COMPONENTS
import SimpleRadial from "@/components/charts/SimpleRadial";
import SuggestionsTable from "@/components/tables/SuggestionsTable.vue";

// CLASS
import {Society} from "@/entities/Society";

export default {
	name: "PagespeedStatistics",
	mixins: [chartsMixin, pageSpeedScoreMixin, utilsMixin, sortMixin],
	components: {
		SimpleRadial,
		StatisticsCardLine,
		SuggestionsTable
	},
	data() {
		return {
			currentUser: VueCookies.get("userInfo"),
			// DATE PICKER DATA
			hasFilter: false,
			loaded: false,
			startFetchingSitemap: false,
			startFetching: false,
			showUrls: null, // BOOLEAN
			society: null,
			allSocieties: null,
			societyUrls: null,
			previousUrl: null,
			loadingPercent: 0,
			backdoor: 0, // incrementable variable for computed property to reload properly
			apiUrl: this.$store.state.backendApiUrl,
			// Data from API
			desktopPagespeedResult: null,
			mobilePagespeedResult: null,
			// Mobile or desktop data depending on which score the user clicked on
			selectedData: null,

			// CHARTS OPTIONS
			reviewChartOptions: null,
			desktopChartOptions: null,
			mobileChartOptions: null
		};
	},

	/**
	 * Before leaving the route
	 * Save the current society selected
	 * So that we dont need to choose it again while looking for other statistics
	 */
	beforeRouteLeave(to, from, next) {
		if(this.selectedSociety != null) {
			this.$store.dispatch("setPreviousSociety", this.selectedSociety);
			next();
		}
		else next();
	},

	created() {
		//console.log("created");
		this.loaded = false;
	},

	computed: {
		/**
		 * Filter audits to fetch opportunities only
		 * And sort them by score ASC (lowest to highest)
		 * PROPS
		 */
		opportunities: function() {
			this.backdoor;
			let final = [];
			Object.entries(this.selectedData.audits).map(i => {
				if(i[1].hasOwnProperty("details") == true) {
					if(
						i[1].details.type == "opportunity" &&
            i[1].score <= 0.89 &&
            i[1].details.items.length >= 1
					) {
						final.push(i[1]);
					}
				}
			});
			return final.sort((a, b) => (a.score > b.score ? 1 : -1));
		},

		/**
		 * Filter audits to fetch diagnostics only
		 * And sort them by score ASC (lowest to highest)
		 * PROPS
		 */
		diagnostics: function() {
			this.backdoor;
			let final = [];
			let ref = this;
			Object.entries(this.selectedData.audits).map(i => {
				if(i[1].hasOwnProperty("details") == true) {
					if(
						i[1].details.type == "table" &&
            i[1].score <= 0.89 &&
            i[1].details.items.length >= 1 &&
            i[1].title != "Tasks"
					) {
						//task is useless here
						final.push(i[1]);
					}
				}
			});
			return final.sort(function(a, b) {
				return (
					(a.score === null) - (b.score === null) ||
          +(a.score > b.score) ||
          -(a.score < b.score)
				);
			});
		},
		selectedSociety(){
			return this.$store.state.activeUserSociety;
		},
	},

	watch: {
		selectedSociety: function(data) {
			// Update the last society item
			sessionStorage.setItem("lastSociety", data.id);
			// RESET ALL DATA
			this.desktopPagespeedResult = null;
			this.mobilePagespeedResult = null;
			this.desktopChartOptions = null;
			this.mobileChartOptions = null;
			this.societyUrls = null;
			this.selectedData = null;
			/*
			 * IF THE SOCIETY ALREADY HAS ALL ITS URL FROM THE SITE MAP
			 * Just show the table (no need to get it again)
			 */
			if(data.urls_from_sitemap != null) {
				this.societyUrls = JSON.parse(data.urls_from_sitemap);
				this.showUrls = true;
			}
			else{
				// Fetch society sitemap
				this.getSitemap(data);
				// Start the bar loader on client change
				this.startBarLoader("societyUrls", true);
			}
		},

		/**
		 * Once getting the data from desktop speedTest
		 * Ask chart data for desktop chart
		 */
		desktopPagespeedResult: {
			deep: true,
			handler: function(data) {
				//console.log("DESKTOP");
				this.getRadialOptions(
					data.categories.performance.score * 100,
					"Ordinateur",
					"desktop"
				);
				this.selectedData = data;
			}
		},

		/**
		 * Once getting the data from mobile speedTest
		 * Ask chart data for mobile chart
		 */
		mobilePagespeedResult: {
			deep: true,
			handler: function(data) {
				//console.log("MOBILE");
				this.getRadialOptions(
					data.categories.performance.score * 100,
					"Mobile",
					"mobile"
				);
				this.selectedData = data;
			}
		}
	},
	methods: {
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		/**
		 * Starts a spinning loader
		 */
		openLoading() {
			this.$vs.loading();
			setTimeout(() => this.$vs.loading.close(), 1000);
		},

		/**
		 * RETRIEVE THE USERS SOCIETY HE IS LINKED TO
		 * @param {number} societyId - ID of the society
		 */
		getUserSociety(societyId) {
			//console.log("getUserSociety");
			this.$http
				.post(this.apiUrl + "society/get/" + societyId)
				.then(res => (this.selectedSociety = res.data))
				.catch(err => console.error(err));
		},

		/**
		 * Query API to fetch all societies
		 */
		getAllSocieties() {
			this.$http.get("society/all").then(res => (this.allSocieties = res.data));
		},

		/**
		 * Query the api to get fetch all the url from a sitemap
		 * @param {ojbect} society - Society object
		 */
		getSitemap(society) {
			//console.log("getSitemap");
			this.$http
				.post(this.apiUrl + "webmaster/sitemaps", {
					society: society
				})
				.then(res => {
					this.societyUrls = res.data.data;
					this.showUrls = true; // display URLs table
				})
				.catch(err => console.error(err));
		},

		/**
		 * Speed test a page
		 * @param {string} url - URL of the page to test
		 * @param {string} strategy - Analysis strategy (mobile or desktop)
		 */
		getPageSpeedInfo(url, strategy) {
			//console.log("getPageSpeedInfo");
			this.showUrls = false; // Hide url table
			this.previousUrl = url; // Save the url of the tested page
			this.$http
				.post(this.apiUrl + "pagespeed/speedtest", {
					url: url,
					strategy: strategy,
					allUrls: this.societyUrls,
					id: this.selectedSociety.id
				})
				.then(res => {
					if(strategy == "desktop") {
						this.desktopPagespeedResult = res.data.data.speedTestResult;
					}
					else{
						this.mobilePagespeedResult = res.data.data.speedTestResult;
					}
					this.societyUrls = res.data.data.urls_from_sitemap;
				})
				.catch(err => console.error(err));
		},

		/**
		 * Check if the data required already exists
		 * If not, ask the API
		 * @param {string} url - Url of the page to test
		 * @param {string} strategy - Device to use for the test
		 */
		checkDataAvailability(url, strategy) {
			// If there're already data saved, check if it does correspond to the one the user ask
			if(this[strategy + "PagespeedResult"] != null) {
				if(this.previousUrl != null && this.previousUrl == url) {
					this.deleteSpeedTestData();
					this.showUrls = false; // hide url table
					this.selectedData = this[strategy + "PagespeedResult"];
					this.reviewChartOptions = this[strategy + "ChartOptions"];
				}
				else{
					this.deleteSpeedTestData();
					// Start the speed test and loader in the same time
					this.getPageSpeedInfo(url, strategy);
					this.startBarLoader(strategy + "PagespeedResult", false);
				}
			}
			else{
				this.deleteSpeedTestData();
				// Start the speed test and loader in the same time
				this.getPageSpeedInfo(url, strategy);
				this.startBarLoader(strategy + "PagespeedResult", false);
			}
		},

		/**
		 * Delete current speed test data (the one that are displayed)
		 */
		deleteSpeedTestData() {
			this.selectedData = null;
			this.reviewChartOptions = null;
		},

		/**
		 * Update the society in the database
		 */
		updateSociety() {
			this.selectedSociety.urls_from_sitemap = this.societyUrls;
			let soc = new Society(this.selectedSociety);
			soc.update(this.selectedSociety.id, (err, result) => {
				if(err) console.error(err);
			});
		},

		/**
		 * Bar loader handler
		 * @param {string} dataToCheck - Name of the data to check
		 * @param {boolean} isFast - If the data is fast to retrieve or not
		 */
		startBarLoader(dataToCheck, isFast) {
			let ref = this;
			let percentManager = null;
			if(!isFast) {
				percentManager = setInterval(function() {
					ref.startFetching = true;
					ref.loadingPercent += 0.5;
					//this.dataReset = false
					if(ref[dataToCheck] != null) {
						ref.loadingPercent = 100;
						setTimeout(function() {
							//console.log("finished");
							ref.startFetching = false;
							ref.loadingPercent = 0;
							this.backdoor++;
						}, 1000);
						clearInterval(percentManager);
					}
				}, 300);
			}
			else{
				percentManager = setInterval(function() {
					ref.startFetchingSitemap = true;
					ref.loadingPercent += 4;
					//this.dataReset = false
					if(ref[dataToCheck] != null) {
						ref.loadingPercent = 100;
						setTimeout(function() {
							//console.log("finished");
							ref.startFetchingSitemap = false;
							ref.loadingPercent = 0;
							this.backdoor++;
						}, 1000);
						clearInterval(percentManager);
					}
				}, 300);
			}
		},

		/**
		 * Get radialchart options with the given parameters
		 * @param {number} data - Loading score of a page
		 * @param {string} chartName - Name of the chart
		 * @param {string} strategy - Name to differenciate mobile and desktop
		 */
		getRadialOptions(data, chartName, strategy) {
			if(strategy == "desktop") {
				// Save a copy in desktopChartOptions
				this.desktopChartOptions = this.setRadialBasicOptions(data, chartName);
				this.reviewChartOptions = this.setRadialBasicOptions(data, chartName);
			}
			else{
				// Save a copy in mobileChartOptions
				this.mobileChartOptions = this.setRadialBasicOptions(data, chartName);
				this.reviewChartOptions = this.setRadialBasicOptions(data, chartName);
			}
		},

		console(data) {
			//console.log(data);
		}
	}
};
</script>

<style scoped>
.comparing_div {
  margin: 5px;
  align-items: center;
}
.comparing_container {
  display: none;
  margin: 5px;
  background-color: rgb(245, 245, 245);
  border-radius: 5px;
}

.center {
  display: flex;
  justify-content: center;
}

.vertical_align {
  align-items: center;
}

.radial_container {
  display: flex;
}
.filter_container {
  display: flex;
  justify-content: space-between;
}

.filter_card {
  margin-bottom: 0 !important;
}

.txt_align_right {
  text-align: right;
}

.pointer {
  cursor: pointer;
}

.metric_container {
  max-width: 40%;
  min-width: 30%;
}

.txt_low {
  color: #ff4e42;
}

.txt_medium {
  color: #ffa400;
}

.txt_high {
  color: #20e647;
}

.fw-bold {
  font-weight: bold;
}

.small_image {
  width: 100%;
  height: 50px;
  object-fit: cover;
}

.img_thumbnail {
  max-width: 40px;
  max-height: 50px;
  padding: 0 !important;
}

.diag_opp_title {
  font-size: 0.8em;
}

.limit_text {
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.url_box {
  word-break: break-word;
}

.img_thumbnail {
  width: 8.5% !important;
}
</style>
